<template>
    <div class="home" v-if="!isPhone">
        <!-- 轮播图1 -->
        <template v-if="webDate">
            <carousel :list="webDate.homeBanner"></carousel>
            <carousel :list="webDate.homecontentBanner" height="1170px" @click="natoBanner"></carousel>
            <carousel :list="webDate.homebottomBanner"></carousel>
        </template>
    </div>

    <div class="phone_home" v-else>
        <template v-if="webDate">
            <phoneCarousel :list="webDate.phoneHomeBanner"></phoneCarousel>
            <phoneCarousel :list="webDate.phoneHomecontentBanner" height="89.25rem"></phoneCarousel>
            <phoneCarousel :list="webDate.phoneHomebottomBanner"></phoneCarousel>
        </template>
    </div>

</template>

<script setup>
import carousel from '../../components/carousel.vue'
import { computed, onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router';
import { getHomeConfig } from '@/api/home/index.js'
import homeBaner from '../../assets/Home/homeBaner.png';
import { useStore } from 'vuex'
import phoneCarousel from "../../components/phoneCarousel.vue"


const store = useStore()
const homeBanner1 = ref([homeBaner]);
const webDate = computed(() => store.state.webDate);
const isPhone = ref(false);
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
if (flag) {
    isPhone.value = true;
}

const router = useRouter()

const natoBanner = () => {
    let path = '';
    if (isPhone.value) {
        path = '/Phone/aboutUs'
    } else {
        path = '/aboutUs'
    }
    router.push({
        path,
    })
}

</script>

<style scoped lang='scss'>
.home {
    padding-top: 87px;
}

.phone_home {
    padding-top: 6.25rem;
}
</style>
